const L = {
  name: "ThumbDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.0061 22H13.6655L16.4058 15.6061C16.5633 15.2384 16.9249 15 17.3249 15H22.0061L22.0061 2L7.2461 2C6.1132 2 5.05991 2.63945 4.55816 3.66987L4.55645 3.6734L2.4628 7.91074L2.45644 7.92465C0.94341 11.2383 3.36963 15 7.0061 15H8.3248C6.96631 18.2568 9.33339 22 13.0061 22ZM16.0061 4L16.0061 13.3054C15.3736 13.6151 14.8563 14.1443 14.5675 14.8182L12.374 19.9364C10.406 19.5315 9.29166 17.2723 10.3442 15.4165L11.7363 13H7.0061C4.82732 13 3.37511 10.7515 4.26989 8.76829L6.35266 4.55298L6.35576 4.5466C6.5147 4.21909 6.8603 4 7.2461 4L16.0061 4ZM18.0061 4L20.0061 4L20.0061 13H18.0061L18.0061 4Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as ThumbDown
};
